<template>
  <v-dialog v-model="dialog" width="800px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("Wave.shopDialogTitle") }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
      <v-divider></v-divider>

      <!-- 表格 -->
      <v-data-table
        :headers="headers"
        :items="details"
        :loading="loading"
        multi-sort
        class="elevation-0 px-6"
        fixed-header
        height="340px"
        hide-default-footer
        disable-pagination
      >
      </v-data-table>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          @click="dialog = false"
          class="elevation-1"
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import Waves from "@/api/waves";

export default {
  name: "StockOrderShopDialog",

  props: {
    value: Boolean,
    items: Object,
  },

  computed: {
    headers() {
      return [
        {
          text: i18n.t("Wave.DetailFields.wave_obj_name"),
          align: "center",
          value: "obj_name",
        },
        {
          text: i18n.t("Wave.DetailFields.stock_order_out_code"),
          align: "start",
          value: "stock_order_code",
        },
      ];
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    details: [],
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
        if (this.dialog && this.items) {
          Waves.fetchOne(this.items.id, { order_activity: 1 }).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.details = response.data.wave.stock_order_wave_details;
              }
            }.bind(this)
          );
        }
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
      },
    },
  },
};
</script>
